import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components';

import { Text } from '../styles';
import colors from '../styles/colors';

const CONTAINER_STYLES = `
  background-color: ${colors.elRed};
  padding: 6px;
  border-radius: 4px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Container = styled(View)`
  ${CONTAINER_STYLES}
`;

const PressableContainer = styled(Pressable)`
  ${CONTAINER_STYLES}
`;

const ButtonText = styled(Text)`
  font-size: 16px;
  color: white;
  font-weight: 600;
  text-decoration-line: none;
  text-align: center;
`;

export const ButtonGroup = styled(View)`
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
`;

export const ButtonContainer = styled(View)`

`;

export const Button = ({ to, label, ...props }) => {
  props.style ||= {};
  const textStyle = {color: '#fff', fontWeight: 'bold', fontSize: '18px',
    textAlign: 'center'
  };

  if ('Cancel' === props.type) {
    props.style.backgroundColor ||= colors.cancel;
    label ||= 'Cancel';
  }

  const content = <ButtonText style={textStyle}>{label}</ButtonText>;

  if (to) {
    return (
      <Container {...props}>
        {/* <Link to={to} style={{textDecoration: 'none'}}>{content}</Link> */}
      </Container>
    );
  } else {
    return <PressableContainer {...props}>{content}</PressableContainer>;
  }

  return content;
}
